import { useState, useEffect } from 'react';
import { AUTH_CONFIG, I18N, REGEX } from 'src/shared/constants/constants';
import { Button, FormField } from 'src/shared/components/index';
import { Box, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { FormFieldType } from 'src/shared/components/form-field/service/formFieldInterface';
import { Grid } from '@mui/material';
import { FormikProvider } from 'formik';
import { useFormik } from 'formik';
import * as ROUTES from '../../shared/constants/routes';
import {
  getLoginDetails,
  selectUserState,
  getLogOutUser,
  setLoginProvider
} from './services/userSlice';

const LoginByUserNamePasswordForm = ({ loginType }) => {
  const { t } = useTranslation(I18N.DEFAULT);
  const dispatch = useDispatch<any>();
  const initialValue = {
    email: '',
    role: 'super-admin'
  };

  const getForgetPasswordPath = () => {
    if (window.location.pathname === ROUTES.ADMIN_LOGIN) {
      return ROUTES.ADMIN_FORGET_PASSWORD;
    } else {
      return ROUTES.FORGET_PASSWORD;
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    validateOnMount: false,
    validate: (value) => {},
    onSubmit: (value: any) => {
      if (
        value.email.trim().length === 0 ||
        value.password.trim().length === 0
      ) {
        //setErrorMessage('Enter valid credentials');
      } else {
        dispatch(setLoginProvider(AUTH_CONFIG.LOGIN_TYPE_BASIC_AUTH));
        dispatch(
          getLoginDetails({
            token: '',
            tokenType: AUTH_CONFIG.LOGIN_TYPE_BASIC_AUTH,
            loginType: loginType,
            username: value.email,
            password: value.password
          })
        );
      }
    }
  });

  const { isValid, handleSubmit } = formik;

  const onSubmit = (values) => {
    handleSubmit();
  };

  const loginFormFields: FormFieldType[] = [
    {
      id: 'email',
      name: 'email',
      type: 'email',
      label: 'Email',
      validations: {
        required: true,
        regex: REGEX.EMAIL
      },
      errorMessages: {
        requiredErrMsg: 'email is required',
        regexErrMsg: 'email is not valid'
      }
    },
    {
      id: 'password',
      name: 'password',
      type: 'password',
      label: 'Password',
      validations: {
        required: true,
        regex: REGEX.PASSWORD
      },
      errorMessages: {
        requiredErrMsg: 'password is required',
        regexErrMsg: 'password is not valid'
      }
    }
  ];

  return (
    <Box className="flex-column-center mb-24">
      <Box className="w-60">
        <FormikProvider value={formik}>
          {loginFormFields?.map((field, index) => (
            <Grid key={index} container direction="row">
              <Grid
                item
                xs={12}
                md={12}
                lg={12}
                xl={12}
                className={index == 0 ? 'mb-16' : ''}
              >
                <FormField fieldProps={field} />
              </Grid>
            </Grid>
          ))}
        </FormikProvider>
        {/* <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Link
            sx={{ pr: 1, fontWeight: '600' }}
            href={getForgetPasswordPath()}
            variant="body2"
          >
            {t('Forgot Password')}?
          </Link>
        </div> */}
        <Button
          btnText="Login"
          className="w-100 mt-15"
          variant={'contained'}
          onClick={onSubmit}
        />
      </Box>
    </Box>
  );
};

export default LoginByUserNamePasswordForm;
